import {PrivateCommand} from "../PrivateCommand";
import {EventManager} from "../../event-manager";

class RemoveEventListenerPrivateCommand extends PrivateCommand {

    public execute(option?: string, callback?: Function): void {
        if (callback) {
            if (!option) {
                callback(false);
            } else {
                callback(EventManager.unsubscribe(parseInt(option)));
            }
        }
    }
}

export {RemoveEventListenerPrivateCommand};
